<template>
  <div class="sales-detail">
    <div class="title">退款进度 Refund schedule</div>
    <div class="steps">
      <el-steps direction="vertical" :active="0" process-status="success">
        <el-step v-for="item in stepsList" :key="item.title">
          <span slot="title">{{ item.title }} {{item.titleEn}} {{ item.time }}</span>
          <span slot="description">{{item.desc}} {{item.descEn}}</span>
        </el-step>
      </el-steps>
    </div>
    <div class="good-detail">
      <div class="order-number">订单编号 Order number：{{ orderStoreNo }}</div>
      <div class="good-box">
        <img class="good-img" :src="detail.coverImage"/>
        <div class="good-info">
          <div class="good-top">
            <div class="good-name">
              <p>{{ detail.name }}</p>
              <p>{{ detail.nameEn }}</p>
            </div>
            <div class="price">￥{{ detail.price }}x{{ detail.qty }}</div>
          </div>
          <div class="good-spec">规格：{{ detail.spec || "单规格" }}</div>
        </div>
      </div>
    </div>
    <div class="refund-feedback">退款反馈 Refund feedback</div>
    <div class="refund-reason">退款原因 Refund reason：{{ detail.reasonChName }} {{ detail.reasonEnName }}</div>
    <div class="img_list">
      <template v-for="item in images">
        <img class="img" :src="item" :key="item"/>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "order",
  components: {},
  data() {
    return {
      stepEnums: {
        0: {
          title: "提交成功",
          titleEn:"Submitted successfully",
          desc: "您的退款申请已提交成功，客服人员将尽快审核处理。",
          descEn:
              "Your refund application has been successfully submitted, the customer service staff will be processed as soon as possible.",
        },
        1: {
          title: "审核通过",
          titleEn: "Approved",
          desc: "您的退款申请已通过审核，请耐心等待退款。",
          descEn: "Your refund application has been approved. Please be patient and wait for your refund.",
        },
        2: {
          title: "审核驳回",
          titleEn:"Review rejection",
          desc: "您的退款申请已被驳回",
          descEn: "Your refund application has been rejected.",
        },
        3: {
          title: "退款成功",
        },
      },
      reasonList: [
        {
          chName: "质量问题",
          enName: "Quality problem",
        },
        {
          chName: "商品错发/漏发",
          enName: "Wrong/missing shipment of goods",
        },
        {
          chName: "显示签收实际收到商品",
          enName: "Show receipt of goods actually received",
        },
        {
          chName: "提货缺货",
          enName: "Pick-up and out-of-stock",
        },
        {
          chName: "其他",
          enName: "Other",
        },
      ],
      detail: {},
      images: [],
      stepsList: [],
      orderStoreNo: "",
    };
  },
  props: {},
  computed: {},
  async mounted() {
    let detail = this.$route.query;
    this.orderStoreNo = detail.orderStoreNo;
    this.getRefundDetail(detail.id);
  },
  methods: {
    getReason:  function (reason) {
      if (typeof reason === "string") {
        reason = parseInt(reason);
      }
      const reasonListSize = this.reasonList.length
      if (reason > reasonListSize) {
        return {chName: '', enName: ''}
      }
      return this.reasonList[reason - 1]
    },
    async getRefundDetail(id) {
      const params = {
        id: id,
      };
      try {
        let {data} = await this.$api.getRefundDetail(params);
        console.log('data', data)
        data.qty = data.refundQty;
        data.goodsVOList = this.formatOrderGood(data);
        const reasonData = this.getReason(data.reason)
        data.reasonChName = reasonData.chName;
        data.reasonEnName = reasonData.enName;
        let stepsList = [];
        let logs = data.logList;
        logs.map((item) => {
          if (item.status != 3) {
            this.stepEnums[item.status].time = item.createTime;
            stepsList.push(this.stepEnums[item.status]);
          } else {
            stepsList.push({
              time: item.createTime,
              title: this.stepEnums[item.status].title,
              desc: `退款总额￥${data.refundAmount}，退款将于1-3个工作日原路退回付款账户，请注意查收，订单使用的优惠券不退回。`,
              descEn: `The total amount of refund is ${data.refundAmount}. The refund will be returned to Dukuan account in 1-3 working days. Please note that the coupons used in the order will not be returned.`,
            });
          }
        });
        this.images = data.refundImages ? data.refundImages.split(",") : [];
        console.log('stepsList=====>', stepsList)
        this.stepsList = stepsList;
        this.detail = data;
      } catch (error) {
        console.log(error + '......');
      }
    },
    formatOrderGood(detail) {
      return [
        {
          coverImage: detail.coverImage,
          name: detail.name,
          nameEn: detail.nameEn,
          spec: detail.spec,
          price: detail.price,
          qty: detail.qty,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.sales-detail {
  margin-top: 25px;

  .title {
    font-size: 18px;

    font-weight: bold;
    color: #333333;
  }

  .steps {
    margin-top: 30px;
    height: 150px;
  }

  .good-detail {
    width: 100%;
    height: 194px;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
    margin-top: 58px;
    padding: 30px;
    box-sizing: border-box;

    .order-number {
      font-size: 14px;

      font-weight: 400;
      color: #333333;
    }

    .good-box {
      width: 100%;
      height: 88px;
      margin-top: 30px;
      display: flex;

      .good-img {
        width: 88px;
        height: 88px;
      }

      .good-info {
        margin-left: 20px;

        .good-top {
          display: flex;
          align-items: center;

          .good-name {
            p {
              font-size: 14px;

              font-weight: 400;
              color: #333333;
            }
          }

          .price {
            font-size: 14px;

            font-weight: 400;
            color: #333333;
            margin-left: 252px;
          }
        }

        .good-spec {
          font-size: 14px;

          font-weight: 400;
          color: #999999;
          margin-top: 20px;
        }
      }
    }
  }

  .refund-feedback {
    font-size: 18px;

    font-weight: bold;
    color: #333333;
    margin-top: 60px;
  }

  .refund-reason {
    font-size: 14px;

    font-weight: 400;
    color: #333333;
    margin: 30px 0;
  }

  .img_list {
    margin: 28px 0 100px 0;
    display: flex;

    .img {
      width: 120px;
      height: 120px;
      margin-right: 20px;
    }
  }
}

.el-step__head {
  display: flex;
  justify-content: center;
}

.is-wait .el-step__icon {
  width: 12px;
  height: 12px;
  background: #333333;

  .el-step__icon-inner {
    font-size: 0;
  }
}

.el-step__head.is-success {
  color: #333333;
  border-color: #333333;

  .is-text {
    width: 20px;
    height: 20px;
  }
}

.el-step__title.is-success {
  color: #333333;
}

.el-step__description.is-success {
  color: #333333;
}
</style>
